<template lang="pug">
	.variative-text-param-editor.flex-col.space-large
		DxCheckBox(v-if="param.DataType === 'boolean'", :value="innerValue", @value-changed="e => innerValue = e.value", stylingMode="filled")
		DxTextBox(v-if="param.DataType === 'string'", :value.sync="innerValue", valueChangeEvent="keyup", stylingMode="filled")
		DxDateBox(v-if="param.DataType === 'date'", ref="datebox", :placeholder="innerValue", :value="dateValue", :dropDownOptions="dateDropDownOptions", @value-changed="v => { innerValue = v.value }", valueChangeEvent="keyup", stylingMode="filled")
		DxNumberBox(v-if="param.DataType === 'number'", :value.sync="numberValue", :show-spin-buttons="true", :show-clear-button="false", valueChangeEvent="keyup", stylingMode="filled")
		DxSelectBox(v-if="param.DataType === 'list' || param.DataType === 'range'", :placeholder="innerValue", stylingMode="filled", 
			:items="param.ListOptions.map(f => ({ key: f.Key || f.key, value: f.Value || f.Key || f.value || f.key }))", value-expr="key", display-expr="value", :search-enabled="false", :value.sync="innerValue")
</template>

<script>	
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import { formatDate } from "dotnet-format";

	export default {
		translationCategory: 'insertion.SSMLVariativeTextEditor',
		name: 'variative-text-param-editor',
		components: {
			DxTextBox,
			DxDateBox,
			DxNumberBox,
			DxSelectBox,
			DxCheckBox
		},
		model: {
			prop: 'value',
			event: 'change '
		},
		props: ['param', 'value'],
		data() {
			return {
				innerValue: this.value,
				dateDropDownOptions: {
					toolbarItems: [
						{
							widget: 'dxButton',
							toolbar: 'bottom',
							location: 'center',
							options: {
								text: () => this.$tCaption('Today'),
								onClick: (e) => {
									console.log('click', e);
									this.$refs.datebox[0].instance.option('value', new Date());
									this.$refs.datebox[0].instance.close();
								}
							}
						}
					]
				}
			};
		},
		computed: {
			dateValue() {
				try {
					let date = new Date(this.innerValue);
					return date instanceof Date && !isNaN(date) ? date : null;
				} catch {
					return null;
				}
			},
			numberValue: {
				get: function() { return parseFloat(this.innerValue) || null; },
				set: function(v) { this.innerValue = v }
			}
		},
		watch: {
			innerValue(v) {
				if (this.$valueUpdating) return;

				let value = this.getValue(v);
				this.$emit('update:value', value);
				this.$emit('change', value);
				if (__DEBUG__)
					console.debug('Change', value);
			},
			value(v) {
				this.$valueUpdating = true;
				this.innerValue = v;
				this.$nextTick(() => this.$valueUpdating = false);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.textParamEditor = this;
			this.$emit('created');
			this.focusInput();
		},
		destroyed() {
			delete this.$valueUpdating;
		},
		methods: {
			focusInput() {
				setImmediate(() => {
					const el = this.$el.querySelector('input');
					if (el) el.focus();
				});
			},
			getValue(v) {
				if (this.param?.DataType === 'date' && this.param?.Format) {
					v = formatDate(v, this.param?.Format);
				}
				return v;
			}
		}
	};
</script>
<style lang='scss'>
	.variative-text-param-editor {
		
	}
</style>
